"use client";

import React from "react";
import useRouteLoader from "@/hooks/use-route-loader";
import GlobalLoader from "@/components/shared/GlobalLoader";

/**
 * Envuelve la app y muestra un loader global
 * durante cambios de ruta usando Framer Motion + Logo.
 *
 * Props:
 * - minDuration: tiempo mínimo en ms que se muestra el loader (default 500ms).
 * - delay: retardo antes de mostrarlo (default 0ms).
 */
export default function RouteLoaderProvider({
  children,
  minDuration = 500,
  delay = 0,
}: React.PropsWithChildren<{ minDuration?: number; delay?: number }>) {
  const isLoading = useRouteLoader({ minDuration, delay });

  return (
    <>
      <GlobalLoader show={isLoading} />
      {children}
    </>
  );
}
